import { z } from 'zod';
import { refineRateMode } from '../_shared';
import {
  apvSavingsCapacityBranch,
  apvIdealPensionBranch,
  apvSelectDefaults,
  APVSelectFormValues,
} from '../apv-select/schema';

export const COMPENSATION_PLAN_OPTIONS = [
  { value: 'A', label: 'Plan A' },
  { value: 'B', label: 'Plan B' },
] as const;

const compensationPlanField = { compensation_plan: z.enum(['A', 'B']) };

export const apvHorizonteSchema = z.discriminatedUnion('savings_option', [
  apvSavingsCapacityBranch.extend(compensationPlanField),
  apvIdealPensionBranch.extend(compensationPlanField),
]).superRefine(refineRateMode);

export type APVHorizonteFormValues = z.infer<typeof apvHorizonteSchema>;

type SavingsCapacityDefaults = Extract<APVSelectFormValues, { savings_option: 'savings_capacity' }>;

export const apvHorizonteDefaults: APVHorizonteFormValues = {
  ...(apvSelectDefaults as SavingsCapacityDefaults),
  death_insured_capital: 1000,
  apv_transfer_amount: 0,
  agreed_premium: 2.2,
  compensation_plan: 'A',
};
